<template>
  <span>TO DO</span>
</template>

<script>
export default {
  name: 'AutomationRulesPage'
}
</script>

<style scoped>

</style>
